"use client";
import React, { useRef } from 'react';
import { avenirNextRegular } from '@/styles/fonts';

const Anchor = (props: {
    href: string,
    children: React.ReactNode,
    isActive?: boolean,
}) => {
    const handleClick = (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
        e.preventDefault();
        const sectionId = e.currentTarget.href.split('#')[1];

        const section = document.getElementById(sectionId);
        if (section) {
            const top = section.getBoundingClientRect().top + window.scrollY - 100;
            window.scrollTo({ top, behavior: 'smooth' });
        }
    }

    const color = props.isActive ? 'text-[#0086b9]' : 'text-[#5e6977]';

    return (<a href={props.href}
        onClick={handleClick}
        className={`${color}
            border-none ${avenirNextRegular.className} 
            ${props.isActive ? 'font-bold' : 'font-normal'}
            text-[19px] 
            lg:text-[23px]
            p-0 
            leading-[36px] 
            whitespace-nowrap`}
        data-toggle="tab"
        role="tab"
        aria-selected={props.isActive}>{props.children}</a>);
};

const NavTabs = () => {
    const scrollRef = useRef<HTMLUListElement>(null);

    const scroll = (direction: 'left' | 'right') => {
        if (scrollRef.current) {
            const amount = 120;
            scrollRef.current.scrollBy({
                left: direction === 'left' ? -amount : amount,
                behavior: 'smooth',
            });
        }
    };

    return (
        <div className="relative w-full">
            <button
                type="button"
                onClick={() => scroll('left')}
                className="sm:hidden absolute left-0 top-1/2 -translate-y-1/2 z-10 w-[28px] h-[28px] flex items-center justify-center text-[#5e6977] active:text-[#0086b9]"
                aria-label="Scroll left"
            >
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <polyline points="10 2 4 8 10 14" />
                </svg>
            </button>
            <div className="px-[32px] sm:px-0 overflow-hidden w-full">
                <ul
                    ref={scrollRef}
                    className="nav nav-tabs nav-tabs-responsive mb-0 flex flex-nowrap sm:justify-between box-border px-1 gap-[16px] sm:gap-0 overflow-x-auto sm:overflow-visible scrollbar-hide w-full min-w-0"
                    role="tablist"
                >
                    <li role="presentation" className="shrink-0 sm:shrink">
                        <Anchor href="#our-story"
                            isActive={true}>Our Story</Anchor>
                    </li>
                    <li role="presentation" className="shrink-0 sm:shrink"><Anchor href="#news">Recent News</Anchor></li>
                    <li role="presentation" className="shrink-0 sm:shrink"><Anchor href="#data">Our Data</Anchor></li>
                    <li role="presentation" className="shrink-0 sm:shrink"><Anchor href="#careers">Careers</Anchor></li>
                    <li role="presentation" className="shrink-0 sm:shrink"><Anchor href="#contactus">Contact Us</Anchor></li>
                </ul>
            </div>
            <button
                type="button"
                onClick={() => scroll('right')}
                className="sm:hidden absolute right-0 top-1/2 -translate-y-1/2 z-10 w-[28px] h-[28px] flex items-center justify-center text-[#5e6977] active:text-[#0086b9]"
                aria-label="Scroll right"
            >
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <polyline points="6 2 12 8 6 14" />
                </svg>
            </button>
        </div>
    );
}

export default NavTabs;